import { Fragment } from 'react';

const styles = {
  heatmapGrid: {
    display: 'grid',
    gridTemplateColumns: 'auto repeat(7, 1fr)',
    gap: '4px',
    alignItems: 'center',
    marginTop: '8px',
  },
  heatmapCell: {
    width: '100%',
    height: '16px',
    minWidth: '18px',
    borderRadius: '3px',
  },
  heatmapCorner: {},
  heatmapDayLabel: {
    textAlign: 'center',
    fontSize: '0.75rem',
    color: '#52514e',
    fontWeight: 600,
  },
  heatmapRowLabel: {
    fontSize: '0.75rem',
    color: '#52514e',
    whiteSpace: 'nowrap',
    paddingRight: '4px',
  },
  heatmapLegend: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '10px',
    fontSize: '0.75rem',
    color: '#898781',
  },
  heatmapLegendSwatch: {
    width: '14px',
    height: '14px',
    borderRadius: '3px',
  },
};

export const DAY_LABELS = {
  day_monday: '月',
  day_tuesday: '火',
  day_wednesday: '水',
  day_thursday: '木',
  day_friday: '金',
  day_saturday: '土',
  day_sunday: '日',
};

export const DAY_ORDER = [
  'day_monday',
  'day_tuesday',
  'day_wednesday',
  'day_thursday',
  'day_friday',
  'day_saturday',
  'day_sunday',
];

const HOURS = Array.from({ length: 24 }, (_, hour) => hour);

const HEATMAP_RAMP = ['#cde2fb', '#86b6ef', '#3987e5', '#1c5cab', '#0d366b'];

// 件数の絶対値でランプ段階を固定する（他の曜日・時間帯や他VTuberとも比較可能にするため）。
const HEATMAP_THRESHOLDS = [1, 3, 6, 10];

const cellKey = (day, hour) => `${day}_${hour}`;

// API は day_* ごとに時刻キー "0"〜"23" の1時間単位カウントを返す。
const flattenHeatmapByHour = (heatmap) => {
  const counts = {};

  DAY_ORDER.forEach((day) => {
    const hourlyCounts = heatmap?.[day] || {};

    HOURS.forEach((hour) => {
      counts[cellKey(day, hour)] = hourlyCounts[String(hour)] || 0;
    });
  });

  return counts;
};

const heatmapCellColor = (count) => {
  let stepIndex = 0;

  HEATMAP_THRESHOLDS.forEach((threshold, index) => {
    if (count >= threshold) {
      stepIndex = index + 1;
    }
  });

  return HEATMAP_RAMP[stepIndex];
};

function StreamHeatmap({ heatmap }) {
  const hourCounts = flattenHeatmapByHour(heatmap);

  return (
    <>
      <div style={styles.heatmapGrid}>
        <div style={styles.heatmapCorner} />
        {DAY_ORDER.map((day) => (
          <div key={day} style={styles.heatmapDayLabel}>
            {DAY_LABELS[day]}
          </div>
        ))}

        {HOURS.map((hour) => (
          <Fragment key={hour}>
            <div style={styles.heatmapRowLabel}>{hour}時</div>
            {DAY_ORDER.map((day) => {
              const count = hourCounts[cellKey(day, hour)];
              return (
                <div
                  key={`${hour}_${day}`}
                  title={`${DAY_LABELS[day]}曜・${hour}時: ${count}件`}
                  style={{
                    ...styles.heatmapCell,
                    background: heatmapCellColor(count),
                  }}
                />
              );
            })}
          </Fragment>
        ))}
      </div>

      <div style={styles.heatmapLegend}>
        {HEATMAP_RAMP.map((color, index) => (
          <Fragment key={color}>
            <span
              style={{ ...styles.heatmapLegendSwatch, background: color }}
            />
            <span>
              {index === 0
                ? '0件'
                : index === HEATMAP_RAMP.length - 1
                ? `${HEATMAP_THRESHOLDS[index - 1]}件〜`
                : `${HEATMAP_THRESHOLDS[index - 1]}件`}
            </span>
          </Fragment>
        ))}
      </div>
    </>
  );
}

export default StreamHeatmap;
